export const ADD_PROJECT = 'SET_PROJECT';
export const ADD_PROJECT_LINK = 'SET_PROJECT_LINK';
export const ADD_RELEASE_ID = 'SET_RELEASE_ID';
export const ADD_SIMPLE_USER_LIST = 'SET_USER_LIST';
export const CLEAR_RELEASE = 'CLEAR_RELEASE';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';

